import React from 'react'

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Us</h2>
        <div className="about-content">
          <p>
            We are more than just developers; we are architects of digital
            innovation. We partner with ambitious businesses to translate
            complex challenges into elegant, high-performance software. Our
            passion for clean code and cutting-edge technology is matched only
            by our commitment to delivering tangible results and building
            lasting relationships.
          </p>
        </div>
      </div>
    </section>
  )
}

export default About